// Bilingual content for BY VAYA — EN / DE
export const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      projects: "Projects",
      contact: "Contact",
      work: "Work With Us",
    },
    hero: {
      kicker: "Creative Strategist · Project Lead · Brand Partner",
      title: "BY VAYA",
      headline: "Connecting People, Places & Brands.",
      description:
        "Strategy, content, branding and experiences designed to create meaningful connections and lasting impact.",
      cta: "Work With Us",
      scroll: "Scroll",
    },
    about: {
      kicker: "About",
      lead:
        "BY VAYA is the strategic and creative partner for brands, founders, businesses and projects — helping them grow, evolve and connect with the right audience.",
      body:
        "Marie combines over a decade across marketing, content, production, events, wellness, project management and brand development — working as a partner from the first idea to final delivery.",
      experience: "A strategic & creative partner — over a decade across strategy, content, production & experiences.",
      link: "More about Marie",
    },
    services: {
      kicker: "What I Help With",
      title: "What I help with",
      intro:
        "Not a list of twenty-five services — four ways I partner with brands, founders and projects, from the first idea to lasting impact.",
      cta: "Start a project",
      buckets: [
        { n: "01", title: "Build", items: ["Branding", "Rebranding", "Websites"], desc: "Foundations and identity — shaping how a brand looks, feels and works, from the ground up." },
        { n: "02", title: "Grow", items: ["Marketing", "Content", "Strategy"], desc: "Direction and momentum — strategy and marketing that earn attention and move the business forward." },
        { n: "03", title: "Create", items: ["Content", "Creative Direction", "Campaigns"], desc: "Story and craft — content, creative direction and campaigns that feel alive and intentional." },
        { n: "04", title: "Connect", items: ["Events", "Experiences", "Partnerships", "Community"], desc: "People and places — events, experiences, partnerships and community that build real connection." },
      ],
    },
    projects: {
      kicker: "Selected Work",
      title: "Selected Projects",
      intro:
        "A quiet portfolio across architecture, surf culture, hospitality and the creative people and places behind them.",
      cta: "View all projects",
      items: [
        { title: "Baleal Wellness", category: "Branding · Massage", year: "2024", desc: "Full brand identity for Daniela Bastos' holistic massage treatments in Baleal — logo, brand board, colour world and strategy. Holistic wellness by the ocean: relax, restore, reconnect." },
        { title: "Casa Atlântica", category: "Architecture · Hospitality", year: "2024", desc: "Brand and creative direction for a boutique coastal stay — architecture-led, quiet and considered." },
        { title: "Off the Point", category: "Surf · Ocean Culture", year: "2024", desc: "A content and storytelling series celebrating surf culture and the rhythm of the Atlantic coast." },
        { title: "Lisboa Stories", category: "Travel · Culture", year: "2023", desc: "An editorial travel series capturing the textures, light and culture of Lisbon." },
        { title: "The Studio Sessions", category: "Production · Content", year: "2023", desc: "End-to-end production and content for a creative studio — from set to final edit." },
        { title: "Long Table", category: "Events · Gatherings", year: "2023", desc: "Concept, production and styling for an intimate long-table dinner series." },
        { title: "Matéria", category: "Craft · Design", year: "2022", desc: "Brand development for a ceramics and design studio, built around material and craft." },
      ],
    },
    process: {
      kicker: "How We Work",
      title: "Process",
      steps: [
        { no: "01", title: "Discover", desc: "We listen, research and understand the heart of your brand." },
        { no: "02", title: "Create", desc: "We shape strategy, identity, content and experience." },
        { no: "03", title: "Connect", desc: "We bring your story to the right people and places." },
        { no: "04", title: "Grow", desc: "We nurture visibility, community and lasting impact." },
      ],
    },
    branding: {
      kicker: "Branding",
      headline: "YOUR BRAND DESERVES ITS FRAME",
      subtext:
        "From building a brand from the ground up to adding the pieces that complete it, every service is shaped with intention. Explore the options below to find yours.",
      cta: "Apply to Work With by VAYA",
      packages: [
        { n: "01", title: "Branding", text: "For founders building something new, or established businesses ready to give their brand the foundation it never had. Branding is where we shape the heart of your business. We start with strategy that helps us differentiate and create what truly fits you and your brand. It's the full arc — from the first idea to a finished identity you can build on for years. If your brand has never had a proper frame, this is where we make one." },
        { n: "02", title: "Rebranding", text: "For businesses that have grown beyond the brand they started with. Rebranding isn't about starting over — it's about realigning what you already have with where you're headed now. We revisit the strategy, refine the visual identity, and make sure every element reflects the business you've become. The result is a brand that finally fits, without losing the recognition you've earned along the way." },
        { n: "03", title: "Brand Direction", text: "For brands with a strong foundation ready to come to life across every channel. This is where your strategy is translated into the real world, with creative direction that keeps everything consistent, intentional and yours. I guide the vision and bring in the right specialists to execute it, so your brand stays cohesive wherever it shows up. You stay focused on your business, while your brand keeps showing up the way it should." },
      ],
    },
    testimonials: {
      kicker: "Kind Words",
      title: "What Our Clients Say",
      items: [
        { quote: "I worked with Marie from by VAYA to rebrand my creative business and I'm completely obsessed with what she created. She nailed the vision I had into a visual look that feels exactly right, tied together with the strategy. You can tell she puts real passion into her work and goes the extra mile to make sure your brand not only looks beautiful but truly resonates with your customers. It was so easy to work with her — I'd highly recommend her for anything branding.", author: "Creative Business Owner", role: "Rebranding Client" },
        { quote: "Marie created the entire brand identity for my massage treatments — the logo, the colours and the whole feeling. It captures 'holistic wellness by the ocean' perfectly and finally feels like me.", author: "Daniela Bastos", role: "Baleal Wellness · Massage Treatments" },
      ],
    },
    clients: {
      kicker: "Selected Clients",
      title: "In good company",
    },
    contact: {
      kicker: "Contact",
      title: "Let’s create something meaningful together.",
      subtitle: "Work with BY VAYA.",
      intro:
        "Tell us about your brand, your place or your idea. We read every message with care.",
      form: {
        name: "Your name",
        email: "Email address",
        subject: "Subject",
        message: "Tell us about your project",
        submit: "Send Inquiry",
        sending: "Sending…",
        success: "Thank you. Your message is on its way — we’ll be in touch soon.",
        error: "Something went wrong. Please try again.",
      },
      details: {
        emailLabel: "Email",
        email: "marie.vayacreative@gmail.com",
        whatsappLabel: "WhatsApp",
        whatsapp: "+351 924 711 317",
        socialLabel: "Follow",
        locationLabel: "Based in",
        location: "Portugal — working worldwide",
      },
    },
    footer: {
      cta: "Work with BY VAYA",
      tagline: "Connecting People, Places & Brands.",
      nav: "Navigate",
      connect: "Connect",
      rights: "All rights reserved.",
      crafted: "Strategy, creative direction & experiences.",
    },
    aboutPage: {
      kicker: "About",
      title: "Not an agency. A strategic & creative partner.",
      p1:
        "BY VAYA is the personal brand and consultancy of Marie — a multidisciplinary creative strategist, project lead and brand partner.",
      p2:
        "Marie combines over a decade of experience across marketing, content, production, events, wellness, project management and brand development.",
      p3:
        "She works as a strategic and creative partner for brands, founders, businesses and projects looking to create meaningful experiences, tell stronger stories and build authentic connections.",
      founder: {
        kicker: "Marie",
        name: "Marie",
        role: "Creative Strategist & Brand Partner",
        bio1:
          "Marie partners with brands the way she believes they're best built — strategically, intentionally and with genuine care for the people behind them.",
        bio2:
          "From first concept to final delivery, she moves across strategy, branding, content, production and experiences — bringing an editor’s eye and a project lead’s discipline to every collaboration.",
      },
      valuesTitle: "What guides us",
      values: [
        { title: "Intentional", desc: "Every choice serves the whole." },
        { title: "Authentic", desc: "Brands made by people, for people." },
        { title: "Timeless", desc: "We design to last, not to trend." },
        { title: "Warm", desc: "Considered work, made with care." },
      ],
    },
  },

  de: {
    nav: {
      about: "Über uns",
      services: "Leistungen",
      projects: "Projekte",
      contact: "Kontakt",
      work: "Zusammenarbeiten",
    },
    hero: {
      kicker: "Creative Strategist · Project Lead · Brand Partner",
      title: "BY VAYA",
      headline: "Menschen, Orte & Marken verbinden.",
      description:
        "Strategie, Content, Branding und Erlebnisse, die bedeutungsvolle Verbindungen und bleibende Wirkung schaffen.",
      cta: "Zusammenarbeiten",
      scroll: "Scrollen",
    },
    about: {
      kicker: "Über uns",
      lead:
        "BY VAYA ist der strategische und kreative Partner für Marken, Gründer:innen, Unternehmen und Projekte — um zu wachsen, sich weiterzuentwickeln und das richtige Publikum zu erreichen.",
      body:
        "Marie vereint über ein Jahrzehnt in Marketing, Content, Produktion, Events, Wellness, Projektmanagement und Markenentwicklung — als Partnerin von der ersten Idee bis zur finalen Umsetzung.",
      experience: "Ein strategischer & kreativer Partner — über ein Jahrzehnt in Strategie, Content, Produktion & Erlebnissen.",
      link: "Mehr über Marie",
    },
    services: {
      kicker: "Womit ich helfe",
      title: "Womit ich helfe",
      intro:
        "Keine Liste aus fünfundzwanzig Leistungen — vier Arten, wie ich Marken, Gründer:innen und Projekte begleite, von der ersten Idee bis zur bleibenden Wirkung.",
      cta: "Projekt starten",
      buckets: [
        { n: "01", title: "Build", items: ["Branding", "Rebranding", "Websites"], desc: "Fundament und Identität — wie eine Marke aussieht, sich anfühlt und funktioniert, von Grund auf geformt." },
        { n: "02", title: "Grow", items: ["Marketing", "Content", "Strategie"], desc: "Richtung und Momentum — Strategie und Marketing, die Aufmerksamkeit verdienen und das Geschäft voranbringen." },
        { n: "03", title: "Create", items: ["Content", "Creative Direction", "Kampagnen"], desc: "Geschichte und Handwerk — Content, kreative Leitung und Kampagnen, die lebendig und bewusst wirken." },
        { n: "04", title: "Connect", items: ["Events", "Erlebnisse", "Partnerschaften", "Community"], desc: "Menschen und Orte — Events, Erlebnisse, Partnerschaften und Community, die echte Verbindung schaffen." },
      ],
    },
    projects: {
      kicker: "Ausgewählte Arbeiten",
      title: "Ausgewählte Projekte",
      intro:
        "Ein ruhiges Portfolio aus Architektur, Surf-Kultur, Hospitality und den kreativen Menschen und Orten dahinter.",
      cta: "Alle Projekte ansehen",
      items: [
        { title: "Baleal Wellness", category: "Branding · Massage", year: "2024", desc: "Komplette Markenidentität für die ganzheitlichen Massage-Treatments von Daniela Bastos in Baleal — Logo, Brand Board, Farbwelt und Strategie. Holistic Wellness by the Ocean: relax, restore, reconnect." },
        { title: "Casa Atlântica", category: "Architektur · Hospitality", year: "2024", desc: "Marke und kreative Leitung für ein Boutique-Küstendomizil — architekturgeführt, ruhig und durchdacht." },
        { title: "Off the Point", category: "Surf · Ozean-Kultur", year: "2024", desc: "Eine Content- und Storytelling-Serie, die Surf-Kultur und den Rhythmus der Atlantikküste feiert." },
        { title: "Lisboa Stories", category: "Reise · Kultur", year: "2023", desc: "Eine redaktionelle Reiseserie, die Texturen, Licht und Kultur Lissabons einfängt." },
        { title: "The Studio Sessions", category: "Produktion · Content", year: "2023", desc: "Produktion und Content von A bis Z für ein Kreativstudio — vom Set bis zum finalen Schnitt." },
        { title: "Long Table", category: "Events · Begegnungen", year: "2023", desc: "Konzept, Produktion und Styling für eine intime Long-Table-Dinner-Serie." },
        { title: "Matéria", category: "Handwerk · Design", year: "2022", desc: "Markenentwicklung für ein Keramik- und Designstudio, rund um Material und Handwerk." },
      ],
    },
    process: {
      kicker: "Wie wir arbeiten",
      title: "Prozess",
      steps: [
        { no: "01", title: "Entdecken", desc: "Wir hören zu, recherchieren und verstehen den Kern Ihrer Marke." },
        { no: "02", title: "Erschaffen", desc: "Wir formen Strategie, Identität, Content und Erlebnis." },
        { no: "03", title: "Verbinden", desc: "Wir bringen Ihre Geschichte zu den richtigen Menschen und Orten." },
        { no: "04", title: "Wachsen", desc: "Wir pflegen Sichtbarkeit, Community und bleibende Wirkung." },
      ],
    },
    branding: {
      kicker: "Branding",
      headline: "DEINE MARKE VERDIENT IHREN RAHMEN",
      subtext:
        "Vom Aufbau einer Marke von Grund auf bis zum Hinzufügen der Bausteine, die sie vollenden — jede Leistung ist mit Absicht geformt. Entdecke unten die Optionen und finde deine.",
      cta: "Mit by VAYA arbeiten",
      packages: [
        { n: "01", title: "Branding", text: "Für Gründer:innen, die etwas Neues aufbauen, oder etablierte Unternehmen, die ihrer Marke endlich das Fundament geben wollen, das sie nie hatte. Branding ist, wo wir das Herz deines Unternehmens formen. Wir starten mit Strategie, die hilft zu differenzieren und das zu schaffen, was wirklich zu dir und deiner Marke passt. Es ist der ganze Bogen — von der ersten Idee bis zur fertigen Identität, auf der du jahrelang aufbauen kannst. Wenn deine Marke nie einen richtigen Rahmen hatte, machen wir hier einen." },
        { n: "02", title: "Rebranding", text: "Für Unternehmen, die über die Marke hinausgewachsen sind, mit der sie begonnen haben. Rebranding bedeutet nicht, von vorn anzufangen — es geht darum, das Vorhandene mit dem auszurichten, wohin du jetzt willst. Wir überdenken die Strategie, verfeinern die visuelle Identität und sorgen dafür, dass jedes Element das Unternehmen widerspiegelt, das du geworden bist. Das Ergebnis ist eine Marke, die endlich passt — ohne die Wiedererkennung zu verlieren, die du dir erarbeitet hast." },
        { n: "03", title: "Brand Direction", text: "Für Marken mit starkem Fundament, die bereit sind, über alle Kanäle hinweg zum Leben zu erwachen. Hier wird deine Strategie in die reale Welt übersetzt, mit kreativer Leitung, die alles konsistent, bewusst und unverkennbar deins hält. Ich führe die Vision und bringe die richtigen Spezialist:innen zur Umsetzung, damit deine Marke überall stimmig bleibt. Du bleibst auf dein Geschäft fokussiert, während deine Marke so auftritt, wie sie sollte." },
      ],
    },
    testimonials: {
      kicker: "Stimmen",
      title: "Was unsere Kund:innen sagen",
      items: [
        { quote: "Ich habe mit Marie von by VAYA mein Kreativ-Business neu gebrandet und bin völlig begeistert von dem, was sie geschaffen hat. Sie hat meine Vision exakt in einen visuellen Look übersetzt, der sich genau richtig anfühlt und mit der Strategie verbunden ist. Man merkt, dass sie echte Leidenschaft in ihre Arbeit legt und die Extrameile geht, damit deine Marke nicht nur schön aussieht, sondern wirklich bei deinen Kund:innen ankommt. Die Zusammenarbeit war so einfach — ich kann sie für alles rund um Branding nur wärmstens empfehlen.", author: "Creative Business Owner", role: "Rebranding-Kundin" },
        { quote: "Marie hat die gesamte Markenidentität für meine Massage-Treatments geschaffen — das Logo, die Farben und das ganze Gefühl. Es bringt 'Holistic Wellness by the Ocean' perfekt auf den Punkt und fühlt sich endlich nach mir an.", author: "Daniela Bastos", role: "Baleal Wellness · Massage-Treatments" },
      ],
    },
    clients: {
      kicker: "Ausgewählte Kund:innen",
      title: "In guter Gesellschaft",
    },
    contact: {
      kicker: "Kontakt",
      title: "Lassen Sie uns gemeinsam etwas Bedeutungsvolles schaffen.",
      subtitle: "Arbeiten Sie mit BY VAYA.",
      intro:
        "Erzählen Sie uns von Ihrer Marke, Ihrem Ort oder Ihrer Idee. Wir lesen jede Nachricht mit Sorgfalt.",
      form: {
        name: "Ihr Name",
        email: "E-Mail-Adresse",
        subject: "Betreff",
        message: "Erzählen Sie uns von Ihrem Projekt",
        submit: "Anfrage senden",
        sending: "Wird gesendet…",
        success: "Vielen Dank. Ihre Nachricht ist unterwegs — wir melden uns bald.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      details: {
        emailLabel: "E-Mail",
        email: "marie.vayacreative@gmail.com",
        whatsappLabel: "WhatsApp",
        whatsapp: "+351 924 711 317",
        socialLabel: "Folgen",
        locationLabel: "Ansässig in",
        location: "Portugal — weltweit tätig",
      },
    },
    footer: {
      cta: "Mit BY VAYA arbeiten",
      tagline: "Menschen, Orte & Marken verbinden.",
      nav: "Navigation",
      connect: "Verbinden",
      rights: "Alle Rechte vorbehalten.",
      crafted: "Strategie, kreative Leitung & Erlebnisse.",
    },
    aboutPage: {
      kicker: "Über mich",
      title: "Keine Agentur. Ein strategischer & kreativer Partner.",
      p1:
        "BY VAYA ist die persönliche Marke und Beratung von Marie — eine multidisziplinäre Creative Strategist, Projektleiterin und Markenpartnerin.",
      p2:
        "Marie vereint über ein Jahrzehnt Erfahrung in Marketing, Content, Produktion, Events, Wellness, Projektmanagement und Markenentwicklung.",
      p3:
        "Sie arbeitet als strategische und kreative Partnerin für Marken, Gründer:innen, Unternehmen und Projekte, die bedeutungsvolle Erlebnisse schaffen, stärkere Geschichten erzählen und echte Verbindungen aufbauen wollen.",
      founder: {
        kicker: "Marie",
        name: "Marie",
        role: "Creative Strategist & Markenpartnerin",
        bio1:
          "Marie begleitet Marken so, wie sie ihrer Überzeugung nach am besten entstehen — strategisch, bewusst und mit echter Fürsorge für die Menschen dahinter.",
        bio2:
          "Vom ersten Konzept bis zur finalen Umsetzung bewegt sie sich zwischen Strategie, Branding, Content, Produktion und Erlebnissen — mit dem Auge einer Redakteurin und der Disziplin einer Projektleiterin.",
      },
      valuesTitle: "Was uns leitet",
      values: [
        { title: "Bewusst", desc: "Jede Entscheidung dient dem Ganzen." },
        { title: "Authentisch", desc: "Marken von Menschen, für Menschen." },
        { title: "Zeitlos", desc: "Wir gestalten für die Dauer, nicht für Trends." },
        { title: "Warm", desc: "Durchdachte Arbeit, mit Sorgfalt gemacht." },
      ],
    },
  },
};

const U = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=82&w=${w}&auto=format&fit=crop`;

export const images = {
  hero: U("1738837546147-fcb60ef09e5d", 2000),
  aboutHero: U("1779140911261-ca87c4cb2a00"),
  founder: U("1492691527719-9d1e07e534b4", 1200),
  texture: U("1486718448742-163732cd1544"),
  architecture: U("1479839672679-a46483c0e7c8"),
  logo: "/by-vaya-logo.png",
};

// Ordered cover images for the projects grid (matches translations.projects.items)
export const projectImages = [
  "/baleal-hero.png", // Baleal Wellness — massage treatment (real client photo)
  U("1479839672679-a46483c0e7c8"), // Casa Atlântica — architecture
  U("1531722569936-825d3dd91b15"), // Off the Point — surfboard
  U("1585208798174-6cedd86e019a"), // Lisboa Stories — tram
  U("1485846234645-a62644f84728"), // Studio Sessions — production
  U("1466978913421-dad2ebd01d17"), // Long Table — gathering
  U("1493106641515-6b5631de4bb9"), // Matéria — ceramics
];

// Gallery images shown in the project modal (matches projects.items order)
export const projectGalleries = [
  ["/baleal-hero.png", "/baleal-massage.png", U("1519823551278-64ac92734fb1", 1400), U("1544161515-4ab6ce6db874", 1400), "/baleal-brandboard.png", U("1556760544-74068565f05c", 1400)],
  [U("1479839672679-a46483c0e7c8", 1400), U("1486718448742-163732cd1544", 1400), U("1567016376408-0226e4d0c1ea", 1400), U("1716467278688-5b7fc38e3ca7", 1400)],
  [U("1531722569936-825d3dd91b15", 1400), U("1502680390469-be75c86b636f", 1400), U("1738837546147-fcb60ef09e5d", 1400), U("1455729552865-3658a5d39692", 1400)],
  [U("1585208798174-6cedd86e019a", 1400), U("1513735492246-483525079686", 1400), U("1469854523086-cc02fe5d8800", 1400)],
  [U("1485846234645-a62644f84728", 1400), U("1452780212940-6f5c0d14d848", 1400), U("1488376986648-2512dfc6f736", 1400), U("1492691527719-9d1e07e534b4", 1400)],
  [U("1466978913421-dad2ebd01d17", 1400), U("1519671482749-fd09be7ccebf", 1400), U("1414235077428-338989a2e8c0", 1400)],
  [U("1493106641515-6b5631de4bb9", 1400), U("1610701596007-11502861dcfa", 1400), U("1610701596061-2ecf227e85b2", 1400)],
];

// Image paired with each service (hover reveal on Services page)
export const serviceImages = [
  U("1610701596061-2ecf227e85b2"), // Creative Direction — design styling
  U("1452780212940-6f5c0d14d848"), // Content Creation — camera
  U("1517842645767-c639042777db"), // Marketing & Strategy — notebook
  U("1488376986648-2512dfc6f736"), // Production & PM — studio
  U("1519671482749-fd09be7ccebf"), // Events & Experiences — gathering
  U("1456513080510-7bf3a84b82f8"), // Brand Development — books / narrative
  U("1495474472287-4d71bcdd2085"), // Partnerships — coffee / collaboration
];

export const LOGO_URL = "/by-vaya-logo.png";
export const LOGO_CREAM_URL = "/by-vaya-logo-cream.png";
export const BALEAL_LOGO_URL = "/baleal-wellness-logo.png";
export const INSTAGRAM_URL = "https://www.instagram.com/by.vaya?igsh=a2hkeHdyOTh3YXdk&utm_source=qr";
export const CONTACT_EMAIL = "marie.vayacreative@gmail.com";
